import React, { useState } from 'react';
import '../css/CareerPage.css';

const CareerPage = () => {
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    role: '',
    motivation: '',
    cv: null
  });

  const jobListings = [
    {
      id: 1,
      title: "Senior UI/UX Designer",
      department: "Design",
      location: "Remote / Hybrid",
      type: "Full-time",
      description: "Shape the future of creator tools with intuitive, beautiful interfaces"
    },
    {
      id: 2,
      title: "React Developer",
      department: "Engineering",
      location: "Remote / Hybrid",
      type: "Full-time",
      description: "Build scalable web applications that empower millions of creators"
    },
    {
      id: 3,
      title: "AI Research Assistant",
      department: "Research",
      location: "Remote",
      type: "Contract",
      description: "Explore cutting-edge AI applications for creative workflows"
    },
    {
      id: 4,
      title: "Brand Strategy Intern",
      department: "Marketing",
      location: "Hybrid",
      type: "Internship",
      description: "Help creators build authentic, impactful personal brands"
    },
    {
      id: 5,
      title: "Product Manager",
      department: "Product",
      location: "Remote / Hybrid",
      type: "Full-time",
      description: "Drive product vision for next-generation creator economy tools"
    },
    {
      id: 6,
      title: "Content Strategist",
      department: "Marketing",
      location: "Remote",
      type: "Full-time",
      description: "Craft compelling narratives that resonate with creative communities"
    }
  ];

  const whyJoinPoints = [
    {
      icon: "🚀",
      title: "Boundary-Pushing Innovation",
      description: "Work alongside visionary thinkers who aren't afraid to challenge the status quo"
    },
    {
      icon: "🌍",
      title: "Flexible Work Culture",
      description: "Hybrid and remote options that respect your work-life balance and creativity"
    },
    {
      icon: "🧪",
      title: "Culture of Experimentation",
      description: "Fail fast, learn faster. We celebrate bold ideas and iterative thinking"
    },
    {
      icon: "💡",
      title: "Direct Creator Impact",
      description: "Build tools that directly empower creators to share their vision with the world"
    },
    {
      icon: "📈",
      title: "Growth & Learning",
      description: "Continuous learning budget, mentorship programs, and career advancement paths"
    }
  ];

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value
    }));
  };

  const handleFileChange = (e) => {
    setFormData(prev => ({
      ...prev,
      cv: e.target.files[0]
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.cv) {
      alert('Please upload your CV.');
      return;
    }

    const submissionData = new FormData();
    // ✅ USE CORRECT BACKEND FIELD NAMES:
    submissionData.append('full_name', formData.name);
    submissionData.append('email_address', formData.email);
    submissionData.append('role_of_interest', formData.role);
    submissionData.append('why_join_red_fibre', formData.motivation);
    submissionData.append('cv_resume', formData.cv);

    try {
      const response = await fetch('http://localhost:8000/api/contact/job-application/', {
        method: 'POST',
        body: submissionData
      });

      if (response.ok) {
        alert('Thank you for your interest! We\'ll be in touch soon.');

        setFormData({
          name: '',
          email: '',
          role: '',
          motivation: '',
          cv: null
        });
        document.getElementById('cv').value = '';
      } else {
        const data = await response.json();
        alert(`Something went wrong: ${JSON.stringify(data)}`);
      }

    } catch (err) {
      console.error('Error submitting form:', err);
      alert('Could not submit. Please try again later.');
    }
  };

  const scrollToJobs = () => {
    document.getElementById('career-jobs-section').scrollIntoView({ 
      behavior: 'smooth' 
    });
  };

  return (
    <div className="career-page">
      {/* Hero Section */}
      <section className="career-hero-section">
        <div className="career-hero-content">
          <h1 className="career-hero-title">Design the Future With Us</h1>
          <p className="career-hero-subtitle">
            Join Red Fibre's mission to empower creators through cutting-edge AI tools, 
            digital branding, and innovative project showcases. Where creativity meets technology.
          </p>
          <button className="career-cta-button" onClick={scrollToJobs}>
            View Open Roles
          </button>
        </div>
        <div className="career-hero-visual">
          <div className="career-floating-elements">
            <div className="career-element career-element-1"></div>
            <div className="career-element career-element-2"></div>
            <div className="career-element career-element-3"></div>
          </div>
        </div>
      </section>

      {/* Why Join Red Fibre */}
      <section className="career-why-join-section">
        <div className="career-container">
          <h2 className="career-section-title">Why Join Red Fibre?</h2>
          <div className="career-why-join-grid">
            {whyJoinPoints.map((point, index) => (
              <div key={index} className="career-why-join-card">
                <div className="career-card-icon">{point.icon}</div>
                <h3 className="career-card-title">{point.title}</h3>
                <p className="career-card-description">{point.description}</p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Open Positions */}
      <section id="career-jobs-section" className="career-jobs-section">
        <div className="career-container">
          <h2 className="career-section-title">Open Positions</h2>
          <div className="career-jobs-grid">
            {jobListings.map(job => (
              <div key={job.id} className="career-job-card">
                <div className="career-job-header">
                  <h3 className="career-job-title">{job.title}</h3>
                  <span className="career-job-type">{job.type}</span>
                </div>
                <div className="career-job-meta">
                  <span className="career-job-department">{job.department}</span>
                  <span className="career-job-location">{job.location}</span>
                </div>
                <p className="career-job-description">{job.description}</p>
                <button className="career-apply-button">Apply Now</button>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Application Form */}
      <section className="career-application-section">
        <div className="career-container">
          <div className="career-application-content">
            <div className="career-application-text">
              <h2 className="career-section-title">Don't See Your Perfect Role?</h2>
              <p className="career-application-description">
                We're always looking for exceptional talent. Send us your CV and tell us 
                how you'd like to contribute to the creator economy revolution.
              </p>
            </div>
            <form className="career-application-form" onSubmit={handleSubmit}>
              <div className="career-form-row">
                <div className="career-form-group">
                  <label htmlFor="name">Full Name</label>
                  <input
                    type="text"
                    id="name"
                    name="name"
                    value={formData.name}
                    onChange={handleInputChange}
                    required
                  />
                </div>
                <div className="career-form-group">
                  <label htmlFor="email">Email Address</label>
                  <input
                    type="email"
                    id="email"
                    name="email"
                    value={formData.email}
                    onChange={handleInputChange}
                    required
                  />
                </div>
              </div>
              <div className="career-form-group">
                <label htmlFor="role">Role of Interest</label>
                <select
                  id="role"
                  name="role"
                  value={formData.role}
                  onChange={handleInputChange}
                  required
                >
                  <option value="">Select a role or department</option>
                  <option value="frontend_developer">Frontend Developer</option>
                  <option value="backend_developer">Backend Developer</option>
                  <option value="fullstack_developer">Full Stack Developer</option>
                  <option value="ui_ux_designer">UI/UX Designer</option>
                  <option value="graphic_designer">Graphic Designer</option>
                  <option value="project_manager">Project Manager</option>
                  <option value="business_analyst">Business Analyst</option>
                  <option value="digital_marketer">Digital Marketing Specialist</option>
                  <option value="content_creator">Content Creator</option>
                  <option value="video_editor">Video Editor</option>
                  <option value="social_media_manager">Social Media Manager</option>
                  <option value="hr_specialist">HR Specialist</option>
                  <option value="sales_executive">Sales Executive</option>
                  <option value="customer_support">Customer Support</option>
                  <option value="data_analyst">Data Analyst</option>
                  <option value="ai_ml_engineer">AI/ML Engineer</option>
                  <option value="devops_engineer">DevOps Engineer</option>
                  <option value="quality_assurance">Quality Assurance</option>
                  <option value="other">Other</option>
                </select>
              </div>
              <div className="career-form-group">
                <label htmlFor="motivation">Why do you want to join Red Fibre?</label>
                <textarea
                  id="motivation"
                  name="motivation"
                  value={formData.motivation}
                  onChange={handleInputChange}
                  rows="4"
                  placeholder="Tell us what excites you about our mission and how you'd contribute..."
                  required
                ></textarea>
              </div>
              <div className="career-form-group">
                <label htmlFor="cv">Upload CV/Resume</label>
                <input
                  type="file"
                  id="cv"
                  name="cv"
                  onChange={handleFileChange}
                  accept=".pdf,.doc,.docx"
                  required
                />
              </div>
              <button type="submit" className="career-submit-button">
                Send Application
              </button>
            </form>
          </div>
        </div>
      </section>
    </div>
  );
};

export default CareerPage;
